exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-db968792]{padding-left:0;display:flex;flex-flow:row wrap}li[data-v-db968792]{list-style-type:none;padding:10px;transition:all .3s ease}.card[data-v-db968792]{display:block;width:230px;height:230px;padding-top:35px;border-radius:7px;text-align:center;line-height:27px;cursor:pointer;position:relative;color:#fff;font-weight:600;font-size:20px;-webkit-box-shadow:9px 10px 22px -8px rgba(209,193,209,.5);-moz-box-shadow:9px 10px 22px -8px rgba(209,193,209,.5);box-shadow:9px 10px 22px -8px rgba(209,193,209,.5);will-change:transform}li[data-v-db968792]:hover{transform:scale(1.1)}li .card[data-v-db968792]{background-color:#302f30}.flip-enter-active[data-v-db968792]{transition:all .4s ease}.flip-leave-active[data-v-db968792]{display:none}.flip-enter[data-v-db968792],.flip-leave[data-v-db968792]{transform:rotateY(180deg);opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-db968792","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-matching-card.vue
// module id = 142
// module chunks = 0